import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { FileInfo } from ".";
import { mapUnsanitizedFileToFile } from "./utils";

export const getFileInfo = (id: number, core: XcoreCore): BaseApiRequest<FileInfo> =>
  core
    .fetch(`/api/file/info/${id}`)
    .then((res) => res.json())
    .then((file) => mapUnsanitizedFileToFile(file));
